import SentimentSidebar from './SentimentSidebar.jsx';
import TopBar from './TopBar.jsx';

/** Layout shell for the marketing Sentiment dashboard — mirrors the XM
 *  Layout but uses the marketing sidebar. */
export default function SentimentLayout({
  title = 'Sentiment Dashboard',
  children,
  stats,
  statsLoading,
  activeQuickFilter,
  onQuickFilter,
}) {
  return (
    <div className="layout">
      <SentimentSidebar
        stats={stats}
        statsLoading={statsLoading}
        activeQuickFilter={activeQuickFilter}
        onQuickFilter={onQuickFilter}
      />
      <main className="main">
        <TopBar title={title} />
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
